import React from "react";

/**
 * Rendert ein Fundstellen-Snippet mit [[…]]-Markern als React-Knoten —
 * Marker werden zu <b>, alles andere bleibt reiner Text (kein innerHTML).
 */
export function renderSnippet(snippet: string): React.ReactNode[] {
  return snippet
    .split(/\[\[(.*?)\]\]/g)
    .map((part, i) =>
      i % 2 === 1 ? <b key={i}>{part}</b> : <React.Fragment key={i}>{part}</React.Fragment>,
    );
}
